import { useShowSearchMetaTooltip } from 'shared/hooks';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAnalytics, useDatesChangeHandler } from './hooks';
import { selectDatesFilter } from 'shared/selectors/filters';
import { DropdownDates, DropdownFilter, useDropdown } from 'shared/components/DropdownFilter';
import { FILTER_KEY } from './constants';
import { trackCloseDatesModal, trackOpenDatesModal } from './tracking';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

export const DatesContainer: FC = () => {
  const {
    label,
    value: { from, to },
    min,
    max,
    size,
  } = useSelector(selectDatesFilter);

  const onChange = useDatesChangeHandler();

  const { opened, onClose, onOpen } = useDropdown(FILTER_KEY);

  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const handleOpen = useCallback(() => {
    onOpen();
    trackOpenDatesModal();
  }, [onOpen]);

  const handleClose = useCallback(() => {
    onClose();
    trackCloseDatesModal();
  }, [onClose]);

  useAnalytics();

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  return (
    <DropdownFilter
      opened={opened}
      onOpen={handleOpen}
      onClose={handleClose}
      showTooltip={showTooltip}
      buttonLabel={label}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={<DropdownDates valueTo={to} valueFrom={from} max={max} min={min} onChange={onChange} />}
      size={size}
    />
  );
};
